import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {TemplateItem} from "../../Model/Catalog/TemplateItem";
import {TemplateFieldsService} from "../../Services/templateFields.service";
import {WarrantyClass} from "../../Model/Catalog/WarrantyClass";
import {fieldNames} from "../../Model/FieldNames";
import {LoginService} from "../../Services/login.service";
import {ValidFeatureSystem} from "../../Model/ValidFeatureSystem";
import {HazmatClass} from "../../Model/Catalog/HazmatClass";
import {ClickEvent, Properties as ButtonProperties} from "devextreme/ui/button";
import {NextPimField} from "../../Model/Catalog/NextPimField";
import {ReorderEvent} from "devextreme/ui/sortable";
import {Column, ColumnButton, ToolbarItem, ToolbarPreparingEvent} from "devextreme/ui/data_grid";
import {TranslateService} from "@ngx-translate/core";

type DropdownFieldSource = {
    id: string;
    display: string;
    translate?: string[],
    active?: boolean
};

@Component({
  selector: 'np-advanced-template-fieldlist',
  templateUrl: './advanced-template-fieldlist.component.html',
  styleUrls: ['./advanced-template-fieldlist.component.css'],
  standalone: false
})
export class AdvancedTemplateFieldListComponent implements OnInit {
  @Input({ required: true }) customerId!: string;
  @Input({ required: true }) templateItem!: TemplateItem;
  @Input({ required: true }) warrantyClasses!: WarrantyClass[];
  @Input({ required: true }) hazmatClasses!: HazmatClass[];
  @Input({ required: true }) validFeatureSystems!: ValidFeatureSystem[];
  
  @Output() templateItemChanged = new EventEmitter<TemplateItem>();
  
  public readonly columns: Array<Column>;

  activeTypeFieldSource: DropdownFieldSource[] ; 
    
  typeFieldSource: DropdownFieldSource[] = [
    {
      id: 'standard',
      display: 'Produkt',
      translate: [
        fieldNames.descriptionShort,
        fieldNames.descriptionLong,
        fieldNames.descriptionLongWithoutHtml,
        fieldNames.manufacturerTypeDescription,
        fieldNames.remarks,
        fieldNames.manufacturerName
      ]
    },
      {id: 'texts', display: 'Texte'},
    {
      id: 'mime',
      display: 'Medien',
      translate: [fieldNames.mimeAlt, fieldNames.mimeDescription]
    },
    {
      id: 'feature',
      display: 'Features',
      translate: [
        fieldNames.featureSystemGroupName,
        fieldNames.featureSystemGroupName,
        fieldNames.fName,
        fieldNames.fUnit,
        fieldNames.fValue
      ]
    },
    { id: 'orderdetail', display: 'OrderDetails' },
    { id: 'price', display: 'Preislisten' },
    { id: 'logistics', display: 'Logistik' },
    { id: 'reference', display: 'Referenzen' },
    { id: 'category', display: 'Kategorien' },
    { id: 'udx', display: 'UDX' },
    { id: 'seo', display: 'SEO - SEA' },
    { id: 'legal', display: 'Recht' },
    {
      id: 'wawi',
        display: this.loginService.wawiSettings?.name && this.loginService.wawiSettings?.name != '' ? this.loginService.wawiSettings?.name : 'Wawi',
        active: this.loginService.hasAddonWawiErp
    },
    { id: 'supplier', display: 'Lieferanten' },
      {id: 'shopware6', display: 'Shopware6', translate: [], active: this.loginService.hasAddonShopware6},
    {
      id: 'packing',
      display: 'Verpackungen',
        translate: [fieldNames.packingUnit],
        active: this.loginService.hasAddonPackaging
    },
      {id: 'kiprompt', display: 'KI-Prompt', translate: [], active: this.loginService.hasAddonKI_TEXTS},
      {id: 'sellsite_neu', display: 'Sellsite', active: this.loginService.hasAddonSellsite_Neu},
      {id: 'sellThroughFigures', display: 'Abverkaufszahlen', active: this.loginService.hasAddonBauvista},
  ];
  
  constructor(
    private translate: TranslateService,
    private loginService: LoginService,
    public fieldService: TemplateFieldsService) {
    this.columns = [
      {
        cellTemplate: 'cell',
        dataField: 'fieldType', // DevExtreme benötigt ein dataField für die Bearbeitung
        setCellValue: (newData, value, currentRowData) => {
          // Diese Funktion wird aufgerufen, wenn die Bearbeitung abgeschlossen ist
          // Da wir custom templates verwenden, müssen wir nichts tun
          // Die Werte werden bereits in den dx-text-box onChange-Events aktualisiert
        }        
      } as Column,
      {
        type: 'buttons',
          buttons: [        
            { 
              icon: 'trash',
              hint: this.translate.instant('Entfernen'),              
              onClick: (e) => this.onRemoveField(e.row.data, e)
            } as ColumnButton
        ]
      } as Column
    ];
  }
  
  ngOnInit() {
    this.activeTypeFieldSource = this.typeFieldSource.filter(x => x.active !== false);
  }
  
  readonly onToolbarPreparing = (e: ToolbarPreparingEvent) => {

    e.toolbarOptions.items.unshift({
      location: 'after',
      locateInMenu: 'auto',      
      widget: 'dxButton',
      options: {
        icon: 'bi bi-plus',
        stylingMode: 'text',
        type: 'default',
        text: this.translate.instant('Feld hinzufügen'),
        onClick: this.onAddNewField
      } as ButtonProperties
    } as ToolbarItem);
  }
  
  readonly itemChanged = () => {
    this.templateItemChanged.emit(this.templateItem);
  }

  readonly onAddNewField = (event: ClickEvent) => {
    this.templateItem.pimFields = [...this.templateItem.pimFields, new NextPimField('-1', '-1', '')];

    this.templateItemChanged.emit(this.templateItem);
  }
  
  readonly onRemoveField = (pimField: NextPimField, event: ClickEvent) => {
    this.templateItem.pimFields.splice(this.templateItem.pimFields.indexOf(pimField), 1);
    this.templateItem.pimFields = [...this.templateItem.pimFields];

    this.templateItemChanged.emit(this.templateItem);
  }

  readonly onReorderFields = (e: ReorderEvent) => {
    var movedFields = this.templateItem.pimFields.splice(e.fromIndex, 1);
    
    this.templateItem.pimFields.splice(e.toIndex, 0, ...movedFields);    
    this.templateItem.pimFields = [...this.templateItem.pimFields];

    this.templateItemChanged.emit(this.templateItem);
  }
}